import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { reviews } from '../../data/blackout';
import { ReviewCard } from './ReviewCard';
import { StarRow } from './StarRow';
const INITIAL_COUNT = 4;
export function ReviewsSection() {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? reviews : reviews.slice(0, INITIAL_COUNT);

  // Summary is computed from the review list — no hard-coded counts.
  const total = reviews.length;
  const average = reviews.reduce((sum, r) => sum + r.rating, 0) / total;
  const distribution = [5, 4, 3, 2, 1].map(stars => ({
    stars,
    count: reviews.filter(r => r.rating === stars).length
  }));
  return <section id="reviews" className="bg-obsidian py-20 md:py-28" data-id="element-268" data-mp="2tlvfm08vcman">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-269" data-mp="2tkansidxvhgh">
        <h2 className="font-display text-5xl uppercase leading-[0.95] text-bone md:text-7xl" data-id="element-270" data-mp="dtocfldkhttn">
          Real people.
          <span className="block text-steel" data-id="element-271" data-mp="8ul8k49bptn9">Real transformations.</span>
        </h2>

        <div className="mt-10 grid gap-8 md:mt-14 lg:grid-cols-12 lg:gap-10" data-id="element-272" data-mp="2593diwvex6rn">
          <div className="lg:col-span-3" data-id="element-273" data-mp="2a8ook5nux5kq">
            <div className="flex items-center gap-4 lg:block" data-id="element-274" data-mp="2a7n1t3xhaun6">
              <p className="font-display text-7xl leading-none text-bone" data-id="element-275" data-mp="2f81amo6wm8m9">{average.toFixed(1)}</p>
              <div className="lg:mt-3" data-id="element-276" data-mp="2k7xbwfo7vly4">
                <StarRow rating={average} size="h-4 w-4" data-id="element-277" data-mp="2k6mces1t10ct" />
                <p className="mt-1.5 text-sm text-steel" data-id="element-278" data-mp="1mkevciobdfjk">
                  Based on {total} reviews
                </p>
              </div>
            </div>
            <ul className="mt-6 space-y-2" aria-label="Rating distribution" data-id="element-279" data-mp="1rgm0i98vyn0g">
              {distribution.map(row => <li key={row.stars} className="flex items-center gap-3 text-[12px] text-steel" data-id="element-280" data-mp="2189qe5psnvzt">
                  <span className="w-8 shrink-0" data-id="element-281" data-mp="13tdyq1ao1w36">{row.stars} ★</span>
                  <span className="h-1.5 flex-1 bg-gunmetal" data-id="element-282" data-mp="13r1k9y44a3uv">
                    <span className="block h-full bg-bone" style={{
                  width: `${row.count / total * 100}%`
                }} data-id="element-283" data-mp="18r74wubyyq3g" />
                  </span>
                  <span className="w-5 shrink-0 text-right" data-id="element-284" data-mp="vretc34lfqi2">{row.count}</span>
                </li>)}
            </ul>
          </div>

          <div className="lg:col-span-9" data-id="element-285" data-mp="1aj6vtejaha2d">
            <div className="grid gap-3 md:grid-cols-2 md:gap-4" data-id="element-286" data-mp="15hzmvc5eu4u4">
              {visible.map(review => <ReviewCard key={review.id} review={review} data-id="element-287" data-mp="htq4kk7enz7q" />)}
            </div>

            {!showAll && total > INITIAL_COUNT && <div className="mt-8 flex justify-center" data-id="element-288" data-mp="cvybvnyxs92h">
                <button type="button" onClick={() => setShowAll(true)} className="group inline-flex h-12 items-center gap-2 border border-bone px-8 text-[12px] font-semibold uppercase tracking-[0.18em] text-bone transition-[background-color,color] duration-150 hover:bg-bone hover:text-obsidian" data-id="element-289" data-mp="rrmej8olwo49">
                  See more reviews
                  <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" data-id="element-290" data-mp="25ouzgcj8f65i" />
                </button>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}